module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/QRlogoPurple.a38f48b11c14be2f91897fb21d4753a9.svg";